export const BIRDVIEW_CARD_SKELETON_TITLE_WIDTHS = ['64%', '48%', '56%']

export const BIRDVIEW_CARD_SKELETON_SUBTITLE_WIDTHS = ['36%', '28%', '42%']
